import React from 'react';
import Icon from '../../components/icons';

export default function ReactIcon(props) {
  // eslint-disable-next-line react/no-danger
  return <span dangerouslySetInnerHTML={{ __html: Icon(props) }} />;
}
